import script from "./vipPage.vue?vue&type=script&setup=true&lang=js"
export * from "./vipPage.vue?vue&type=script&setup=true&lang=js"

import "./vipPage.vue?vue&type=style&index=0&id=2bf83c14&lang=less&scoped=true"
import "./vipPage.vue?vue&type=style&index=1&id=2bf83c14&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/qpyx-korea-gm/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bf83c14"]])

export default __exports__